import React,{ useState } from 'react'
import Grid  from "@mui/material/Grid"
import useMediaQuery from '@mui/material/useMediaQuery';
import { BrowserRouter , Route, Routes, Switch, Link, Redirect } from 'react-router-dom'
import { Edit, Close } from "@mui/icons-material";
import CreateEmployee from './CreateEmployee';
import EditEmployee from './EditEmployee';
import ListEmployee from './ListEmployeeV1';
import ShowEmployee from './ShowEmployee';
import UpdatePassword from './UpdatePassword';



function Employee(props) {
  const matches = useMediaQuery('(min-width:1080px)');
  React.useEffect(() => {
    props.setIsSelected("Employee Details") 
    return () => {
      
    }
  }, [])
    // console.log(props)

    
  return (
    <div style={{padding:"1rem"}}>
      <Routes>
        <Route exact path='/' element={<ListEmployee />}/>
        <Route exact path='/update-password' element={<UpdatePassword />}/>
        <Route exact path='/create' element={<CreateEmployee />}/>
        <Route exact path='/edit/:id' element={<EditEmployee />}/>
        <Route exact path='/show/:id' element={<ShowEmployee />}/>
      </Routes>
    </div>
  )
}

export default Employee